import React from 'react';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {Garlic,Fishery} from '../../../assets/images/images';
// import Card from './bestSellerCarouselCard'
import './style.scss'

// const responsive = {
//   desktop: {
//     breakpoint: {max: 3000, min: 1024},
//     items: 1,
//     slidesToSlide: 1 // optional, default to 1.
//   },
//   tablet: {
//     breakpoint: {max: 1024, min: 1024},
//     items: 1,
//     slidesToSlide: 5 // optional, default to 1.
//   },
//   mobile: {
//     breakpoint: {max: 464, min: 0},
//     items: 1,
//     slidesToSlide: 1 // optional, default to 1.
//   }
// };

const responsive = {
  desktop: {
    breakpoint: {max: 3000, min: 1024},
    items: 1,
    paritialVisibilityGutter: 60
  },
  tablet: {
    breakpoint: {max: 1024, min: 464},
    items: 1,
    paritialVisibilityGutter: 50
  },
  mobile: {
    breakpoint: {max: 464, min: 0},
    items: 1,
    paritialVisibilityGutter: 30
  }
};

const data = [3, 3, 3, 3, 3, 3, 3, 3, 33,]
const Card = ({index, key}) => {
  return (
    <div className={'display-flex align-items-center flex-column'}>
      <p>{index}{key}</p>
      <img src={index%2?Garlic:Fishery} alt={''} style={{width:'50%',height:'100%',}}/>
    </div>
  )
}

function Index(props) {
  return (
    <div className='best-seller-carousel-container-removed-class'>
      <Carousel
        swipeable={true}
        draggable={true}
        showDots={true}
        renderButtonGroupOutside={true}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={800}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={800}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        // deviceType={this.props.deviceType}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px "

      >
        {data.map((item, index) => (
          <Card index={index} key={index} item={item}/>
        ))}
      </Carousel>
    </div>
  );
}

export default Index;
